module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/096-mozambique-410d67c97a5d7f3adf3d09dae606a298.svg";